import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../../Components/HttpService/HttpService';

export const getQuestions = payload => ({
    type: 'FETCH_QUESTIONS_SUCCESS',
    payload,
});

export function getDataRequested() {
    return {
        type: 'GET_DATA_REQUESTED'
    };
}

export function getDataDone(data) {
    return {
        type: 'GET_DATA_DONE',
        payload: data
    };
}

export function getDataFailed(error) {
    return {
        type: 'GET_DATA_FAILED',
        payload: error
    };
}

export function setValueChecked(value) {
    return {
        type: 'SET_VALUE_CHECKED',
        payload: value
    };
}

export function getData(type, selectedPrograms, callback, pageSize, pageNumber, filters, sorting) {
    let url = PropertyBucket.urlQuestions(type, pageSize, pageNumber);
    
    const payload = {selectedPrograms, filters: filters, sortingField: sorting.index, isDesc: sorting.direction === 'desc' ? true : false};

    return dispatch => {
        dispatch(getDataRequested());
        let response = httpService.getServicePromise(url, "POST", payload);
        response.then(data => {
            dispatch(getDataDone(data));
            if (callback) {
                callback();
            }
            })
            .catch(error => {
                dispatch(getDataFailed(error));
            })
    }
}

export function getStandardQuestionsByBlock(blockId){
     let url = PropertyBucket.getStandardQuestionsByBlock(blockId);
     this.controlResponse = httpService.getService(url, "GET");
       return dispatch => {
           dispatch(getDataRequested());
           this.controlResponse.then(response => response.json()).then(data => dispatch(getDataDone(data)));
         }
}

export function saveQuestionsToRedux(questions){
    return dispatch => {dispatch(getDataDone(questions))}
      }


export function getQuestionsByBlock(blockId){
     let url = PropertyBucket.getQuestionsByBlock(blockId);
     this.controlResponse = httpService.getService(url, "GET");
       return dispatch => {
           dispatch(getDataRequested());
           this.controlResponse.then(response => response.json()).then(data => dispatch(getDataDone(data)));
         }
}

export const GET_DATA_REQUESTED = 'GET_DATA_REQUESTED';
export const GET_DATA_DONE = 'GET_DATA_DONE';
export const GET_DATA_FAILED = 'GET_DATA_FAILED';

